import React from "react";

export const TiresLayer = ({ count = 24 }) => {
  const stripes = ["#ff2d2d", "#ffd93d", "#f1f5f9"]; // soft/medium/hard
  const items = Array.from({ length: count }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 1.2,
    duration: 6 + Math.random() * 3.5,
    size: 38 + Math.floor(Math.random() * 18),
    stripe: stripes[i % stripes.length],
  }));
  return (
    <div className="pointer-events-none fixed inset-0 z-30 overflow-hidden">
      <style>{`@keyframes tireFall {0%{transform:translateY(-15vh) rotate(0deg)}100%{transform:translateY(120vh) rotate(720deg)}}`}</style>
      {items.map((t) => (
        <div
          key={t.id}
          style={{
            position: "absolute",
            top: "-15vh",
            left: `${t.left}%`,
            width: t.size,
            height: t.size,
            animation: `tireFall ${t.duration}s ease-in ${t.delay}s forwards`,
          }}
        >
          <div style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "#111", boxShadow: "inset 0 0 0 6px #222, inset 0 0 0 12px #333" }} />
          <div style={{ position: "absolute", inset: "28%", borderRadius: "50%", background: "#000" }} />
          <div style={{ position: "absolute", top: "50%", left: "12%", right: "12%", height: 4, background: t.stripe, transform: "translateY(-50%)" }} />
        </div>
      ))}
    </div>
  );
};
